/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './library-creative-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {CreativeBulkActionService} from '../creative/creative-bulk-action.service';
import {asUrlGroupList, asUrlList} from '../creative/creative-url-utils';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-library-creative-list-page',
  template
})
export class LibraryCreativeListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.library-creatives.library-creative';
  readonly layoutItemStateName = 'app.adm.layouts.layout';

  private readonly fallbackColumns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'Layout', label: 'layout'},
    {param: '', label: 'URLs', sortable: false},
    {param: 'width', label: 'dimensions', sortable: false},
    {param: 'updateTime'},
    {param: '', label: 'targeting', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly creativeBulkActionService: CreativeBulkActionService
  ) {
    super(LocalNetworkProfile);
  }

  get visibleColumns(): AdminListColumn[] {
    return this.normalizeColumns(this.list?.creativeFields || this.fallbackColumns);
  }

  get sortHeaderParams(): any[] {
    if (this.list?.sel?.outputFields?.length) {
      return this.list.sel.outputFields;
    }
    return this.list?.creativeFields || this.fallbackColumns;
  }

  layoutLinkDisabled(): boolean {
    return this.list?.perms?.MANAGE_LAYOUTS !== true;
  }

  constraintUrls(creative: any): string[] {
    return asUrlList(creative?.constraintsToUrls);
  }

  assetHtmlUrlGroups(creative: any): string[][] {
    return asUrlGroupList(creative?.assetHtmlUrls);
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    if (!this.list.bulkAction) {
      this.list.bulkAction = this.creativeBulkActionService.createBulkAction(this.list);
    }
  }
}
